/**
 * Split Step Handler (A/B Testing)
 * Randomly splits the flow between two paths based on percentage
 */

import type {
  StepExecutionContext,
  StepExecutionResult,
  SplitStepConfig
} from '../../types/workflow';

export async function executeSplit(
  context: StepExecutionContext
): Promise<StepExecutionResult> {
  try {
    const config = context.step.config as SplitStepConfig;

    if (config.split_percentage_a === undefined) {
      return {
        success: false,
        error: 'Missing required field: split_percentage_a',
      };
    }

    // Generate random number between 0 and 100
    const random = Math.random() * 100;

    // Determine which path to take
    const takePathA = random < config.split_percentage_a;

    console.log(`🔱 Split: random=${random.toFixed(2)}, percentage_a=${config.split_percentage_a}, taking path ${takePathA ? 'A' : 'B'}`);

    // Determine next step based on split result
    const nextStepId = takePathA
      ? context.step.split_next_step_a_id
      : context.step.split_next_step_b_id;

    if (!nextStepId) {
      console.log(`⚠️ No next step configured for path ${takePathA ? 'A' : 'B'}`);
    }

    return {
      success: true,
      nextStepId: nextStepId || null,
      data: { path: takePathA ? 'A' : 'B', random },
    };
  } catch (error) {
    console.error('Error in split handler:', error);
    return {
      success: false,
      error: (error as Error).message,
    };
  }
}
